import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "mHead",
  computed: {
    ...walletVuex.mapState(["isMobile"]),
    ...userVuex.mapState(["userInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    return {
      popBuyDiamindShow: false,
      isBuyTicketListLoading: false,
      diamondPriceList: [],
      choiceLoading: false
    };
  },
  methods: {
    ...userVuex.mapActions(["getBuyTicketList", "paymentTicket", "paymentDepositStars", "openInvoiceStarPay", "getLoginInfo", "checkPaymentStars"]),
    async onDiamondShow() {
      this.popBuyDiamindShow = true;
      await this.getTicketPrice();
    },
    async getTicketPrice() {
      if (this.isBuyTicketListLoading) return;
      this.isBuyTicketListLoading = true;
      const diamondPriceList = await this.getBuyTicketList();
      if (!diamondPriceList) {
        this.isBuyTicketListLoading = false;
        return;
      }
      this.isBuyTicketListLoading = false;
      this.diamondPriceList = diamondPriceList;
    },
    async onPayTicket(item) {
      item.isLoading = true;
      const res = await this.paymentTicket({
        priceId: item.id
      });
      console.log("res======123", res, item);
      if (!res) {
        item.isLoading = false;
        return;
      }
      const starRes = await this.openInvoiceStarPay({
        url: res.chainInfo.payment_url
      });
      if (!starRes) {
        item.isLoading = false;
        return;
      }
      this.choiceLoading = true;
      const checkRes = await this.checkPaymentStars({
        order_id: res.chainInfo.order_id
      });
      console.log("checkRescheckRescheckRes", checkRes);
      if (!checkRes) {
        this.choiceLoading = false;
        return;
      }
      this.choiceLoading = false;
      item.isLoading = false;
      this.popBuyDiamindShow = false;
      if (checkRes?.userInfo) {
        this.taskInfo.popCoinAnim.userInfo = checkRes?.userInfo;
        this.taskInfo.popCoinAnim.endId = "diamondBalanceId";
        await new Promise(resolve => setTimeout(resolve, 500));
        this.taskInfo.popCoinAnim.reward = item.diamond;
        this.taskInfo.popCoinAnim.icon = "diamond";
        this.taskInfo.popCoinAnim.show = true;
      }
    }
  }
};